module.exports = require('./helpers/bundle-url').getBundleURL('1G2bZ') + "db.abb7ea0e.svg" + "?" + Date.now();